type F<T,Ret> = (obj:T) => Ret;

export const as = <T,Ret>(obj:any, func:F<T,Ret>):Ret => func(obj);